import Entrega from "../../../views/administrador/Ventas/Entrega";
import EntregaCombustible from "../../../views/administrador/Ventas/EntregaCombustible";
import FacturasFfacsa from "../../../views/administrador/Ventas/FacturasFfacsa";




const VentasRoutes = [
  {
    path: "/Entrega",
    name: "Entrega",
    icon: "",
    component: Entrega,
    doNotShow: true,
  },
  {
    path: "/EntregaCombustible",
    name: "Entrega Combustible",
    icon: "",
    component: EntregaCombustible,
    doNotShow: true,
  },
  {
    path: "/FacturasFfacsa",
    name: "Facturas Ffacsa",
    icon: "",
    component: FacturasFfacsa,
    doNotShow: true,
  },

 
];

export default VentasRoutes;
